/* tslint:disable */
/* eslint-disable */
export enum CleanVehicleType {
  Unknown = 'Unknown',
  Fee = 'Fee',
  Rebate = 'Rebate',
  NotEligible = 'NotEligible',
  NoFeeOrRebate = 'NoFeeOrRebate'
}
